import $http from '@/plugins/axios'

const CredentialsService = {
    getListCredentials (projectId = 2) {
        return $http.get(`/projects/${projectId}/credentials/`).then(
            response => Promise.resolve(response.data),
            error => Promise.reject(error)
        )
    },
    createAPIKeys (projectId = 1, name = '') {
        return $http.post(`/projects/${projectId}/credentials/`, { name: name })
    },
    deleteAPIKeys (projectId = 1, apiKey = 1) {
        return $http.delete(`/projects/${projectId}/credentials/${apiKey}/`).then(
            response => response.status === 204 ? Promise.resolve(response) : Promise.reject(response),
            error => Promise.reject(error)
        )
    },
    getCredentials (projectId) {
        return $http.get(`/projects/${projectId}/credentials/`)
    }
}

export default CredentialsService
